import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import {Autoplay, Pagination} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.js-banner-slider');

    if (!sliders.length) {
        return;
    }

    sliders.forEach((slider) => {
        const slides = slider.querySelectorAll('.swiper-slide');

        if (slides.length <= 1) {
            return;
        }

        const disableAutoplay = slider.dataset.disableAutoplay === 'true';

        new Swiper(slider, {
            modules: [Autoplay, Pagination],

            loop: true,

            autoplay: disableAutoplay
                ? false
                : {
                      delay: 5000,
                      disableOnInteraction: false,
                  },

            pagination: {
                el: slider.querySelector('.banner__dots'),
                clickable: true,
                bulletClass: 'banner__dot',
                bulletActiveClass: 'banner__dot--active',
            },

            allowTouchMove: true,
        });
    });
});
